import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";

import BettingPlace, { newBettingPlace } from "../../models/betting-places";
import BettingPlaceForm from "./BettingPlaceForm";

interface BettingPlaceUpdateModalProps {
  show: boolean;
  bettingPlace?: BettingPlace;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const BettingPlaceUpdateModal: React.FC<BettingPlaceUpdateModalProps> = ({
  show,
  bettingPlace,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialBettingPlace, setInitialBettingPlace] = useState<BettingPlace>(
    bettingPlace ? bettingPlace : newBettingPlace()
  );

  const modalTitle = bettingPlace
    ? `Editar Lugar: ${bettingPlace.name}`
    : `Crear Lugar nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialBettingPlace(newBettingPlace());
    onCancel();
  };

  useEffect(() => {
    setInitialBettingPlace(bettingPlace ? bettingPlace : newBettingPlace());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bettingPlace]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <BettingPlaceForm
            initialBettingPlace={initialBettingPlace}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default BettingPlaceUpdateModal;
